import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../ui/Button';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="w-full bg-white/90 backdrop-blur-sm shadow-[0px_4px_32px_rgba(136,136,136,0.1)] rounded-xl xs:rounded-2xl">
      <div className="flex justify-between items-center px-3 xs:px-4 sm:px-6 lg:px-4 py-3 xs:py-4">
        {/* Logo Section */}
        <div className="flex items-center flex-shrink-0">
          <a href="/" className="flex items-center">
            <img 
              src="/images/averpact-logo-full.svg" 
              alt="AverPact" 
              className="h-12 xs:h-14 sm:h-16 w-auto"
            />
          </a>
        </div>

        {/* Navigation Menu - Desktop */}
        <nav className="hidden lg:block">
          <ul className="flex items-center gap-4 xl:gap-6">
            <li>
              <a 
                href="#hero"
                className="text-sm xl:text-base font-normal leading-tight text-black-semi hover:text-primary-orange transition-colors whitespace-nowrap"
                role="menuitem"
              >
                Home
              </a>
            </li>

            <li>
              <a 
                href="#process"
                className="text-sm xl:text-base font-normal leading-tight text-black-semi hover:text-primary-orange transition-colors whitespace-nowrap"
                role="menuitem"
              >
                How It Works
              </a>
            </li>
            <li>
              <a 
                href="#faq"
                className="text-sm xl:text-base font-normal leading-tight text-black-semi hover:text-primary-orange transition-colors whitespace-nowrap"
                role="menuitem"
              >
                FAQs
              </a>
            </li>
            <li>
              <a 
                href="#cta"
                className="text-sm xl:text-base font-normal leading-tight text-black-semi hover:text-primary-orange transition-colors whitespace-nowrap"
                role="menuitem"
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>

        {/* Right Section */}
        <div className="flex items-center gap-1.5 xs:gap-2 sm:gap-3 flex-shrink-0">
          {/* Get Started Button - Desktop */}
          <div className="hidden lg:block">
            <Link to="/dashboard">
              <Button
                text="Get Started"
                text_font_size="14"
                text_font_family="DM Sans"
                text_font_weight="500"
                text_line_height="18px"
                text_color="#ffffff"
                fill_background="linear-gradient(180deg, #FF3333 0%, #FF3333 100%)"
                border_border_radius="8px"
                className="px-3 xs:px-4 py-1.5 xs:py-2 whitespace-nowrap text-sm"
              />
            </Link>
          </div>

          {/* Hamburger Menu Icon (Mobile only) */}
          <button 
            className="block lg:hidden p-1.5 xs:p-2" 
            aria-label="Toggle menu"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <svg className="w-5 h-5 xs:w-6 xs:h-6 text-black-semi" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {menuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {menuOpen && (
        <nav className="lg:hidden border-t border-gray-100">
          <ul className="flex flex-col py-3 xs:py-4 px-3 xs:px-4 space-y-2 xs:space-y-3">
            <li>
              <a 
                href="#hero"
                className="w-full text-left text-sm xs:text-base font-normal leading-tight text-black-semi hover:text-primary-orange transition-colors py-2"
                role="menuitem"
                onClick={() => setMenuOpen(false)}
              >
                Home
              </a>
            </li>

            <li>
              <a 
                href="#process"
                className="w-full text-left text-sm xs:text-base font-normal leading-tight text-black-semi hover:text-primary-orange transition-colors py-2"
                role="menuitem"
                onClick={() => setMenuOpen(false)}
              >
                How It Works
              </a>
            </li>
            <li>
              <a 
                href="#faq"
                className="w-full text-left text-sm xs:text-base font-normal leading-tight text-black-semi hover:text-primary-orange transition-colors py-2"
                role="menuitem"
                onClick={() => setMenuOpen(false)}
              >
                FAQs
              </a>
            </li>
            <li>
              <a 
                href="#cta"
                className="w-full text-left text-sm xs:text-base font-normal leading-tight text-black-semi hover:text-primary-orange transition-colors py-2"
                role="menuitem"
                onClick={() => setMenuOpen(false)}
              >
                Contact
              </a>
            </li>
            <li className="pt-2">
              <Link to="/dashboard" className="block" onClick={() => setMenuOpen(false)}>
                <Button
                  text="Get Started"
                  text_font_size="16"
                  text_font_family="DM Sans"
                  text_font_weight="500"
                  text_line_height="21px"
                  text_color="#ffffff"
                  fill_background="linear-gradient(180deg, #FF3333 0%, #FF3333 100%)"
                  border_border_radius="8px"
                  className="w-full px-4 py-2 text-sm xs:text-base"
                />
              </Link>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
};

export default Header;